﻿import React, {ComponentPropsWithoutRef, FC} from 'react';
import {Grid, GridOwnProps} from "@mui/material";

type SortFilterItemContainerProps = GridOwnProps & ComponentPropsWithoutRef<'div'>;

/**
 * Container for individual sort/filter items within a {@link SortFilterContainer}.
 * Should be wrapped by {@link SortFilterContainer}.
 * Simple wrapper around MUI Grid item.
 *
 * @see {@link SortFilterContainer}
 *
 * @example
 * <SortFilterContainer>
 *   <SortFilterItemContainer sm={6}>
 *     <!-- Sort/filter item content here -->
 *   </SortFilterItemContainer>
 * </SortFilterItemContainer>
 *
 * @param props - See {@link Grid} API for available props
 * @constructor
 */
const SortFilterItemContainer: FC<any> = (props: SortFilterItemContainerProps) => {
  return <Grid item alignContent={'end'} xs={12} sm {...props} />
}

export { SortFilterItemContainer };
